module.exports = __webpack_public_path__ + "static/media/ABBALegend.259d6ecf.png";